import { css } from '@emotion/react';
import { GradientStriped } from './mixins/_gradients.mixin';
import { FontSize } from './vendor/_rfs.mixin';
import { BorderRadius } from './mixins/_border-radius.mixin';
import { BoxShadow } from './mixins/_box-shadow.mixin';
import { Transition } from './mixins/_transition.mixin';


export default $ => css`
  ${$.enableTransitions && css`
    @keyframes progress-bar-stripes {
      from { background-position: ${$.progressHeight} 0; }
      to { background-position: 0 0; }
    }
  `}

  .progress {
    display: flex;
    height: ${$.progressHeight};
    overflow: hidden;
    line-height: 0;
    ${new FontSize($.progressFontSize).include($)};
    background-color: ${$.progressBg};
    ${new BorderRadius($.progressBorderRadius).include($)};
    ${new BoxShadow($.progressBoxShadow).include($)};
  }

  .progress-bar {
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;
    color: ${$.progressBarColor};
    text-align: center;
    white-space: nowrap;
    background-color: ${$.progressBarBg};
    ${new Transition($.progressBarTransition).include($)};
  }

  .progress-bar-striped {
    ${new GradientStriped().include($)};
    background-size: ${$.progressHeight} ${$.progressHeight};
  }

  ${$.enableTransitions && css`
    .progress-bar-animated {
      animation: ${$.progressBarAnimationTiming} progress-bar-stripes;

      ${$.enablePrefersReducedMotionMediaQuery ? css`
        @media (prefers-reduced-motion: reduce) {
          animation: none;
        }
      ` : css``}
    }
  `}
`;
